import Bb from 'backbone';
import { View } from 'backbone.marionette';

import template from './index.jst';

class SetupAccountView extends View {

	get template() {
		return template;
	}

	get className() {
		return "onboarding-form onboarding-setup-account";
	}

	ui() {
		return {
			next: '.js-next',
			cancel: '.js-cancel',
			link_to_different_account: '.js-link-to-different-account'
		};
	}

	events() {
		return {
			'click @ui.next': 'onClickNext',
			'click @ui.cancel': 'onClickCancel',
			'click @ui.link_to_different_account': 'onClickLinkToDifferentAccount'
		};
	}

	initialize() {
		this.onboarding = this.getOption('onboarding');
		this.model = new Bb.Model();

		this.setDefaultValues();
	}

	setDefaultValues() {
		this.model.set({
			game_title : this.onboarding.get('game_title'),
			email : this.onboarding.get('user').email
		});
	}

	onClickNext(e) {
		e.preventDefault();
		this.onboarding.set({
			current_step: 'MatchStartPlaying',
			MatchStartPlaying_back_url: 'SetupAccount',
			user_login_type: 'email'
		});
	}

	// Not sure if cancel button is required, it is in designs but
	// there is no direction for what cancel should do.
	onClickCancel(e) {
		e.preventDefault();
	}

	onClickLinkToDifferentAccount(e) {
		e.preventDefault();
		this.onboarding.set({
			current_step: 'LinkAccount',
			LinkAccount_back_url: 'SetupAccount'
		});
	}
}

export default SetupAccountView;